import { IconCurrencyRupee } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import nodata from "../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { GetRequest } from '../../../Utils/hooks/ApiHandler'
import { useNavigate } from 'react-router-dom'
import useLocalStorageState from 'use-local-storage-state'

export const TopDeals = () => {
    const [customer, setCustomer] = useLocalStorageState("customer")
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const navigate = useNavigate()

    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    const [topDeals, setTopDeals] = useState(null)
    // api fetch for top deals
    useEffect(() => {
        ; (async () => {
            const res = await GetRequest(
                `dashboard/topDeals/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                { headers },
                extras
            )
            if (res.status === false) {
                return
            }
            setTopDeals(
                res.data &&
                res.data?.map((c) => ({
                    name: c.deal_name,
                    email: c.email,
                    amount: `${Number(c.totalBudget).toFixed(2)}`,
                    avatar: true,
                }))
            )
        })()
    }, [])

    return (
        <div className='card ' style={{ paddingBottom: '1.75rem' }}>
            <div className="addEnquiryHead " style={{ fontWeight: 600, paddingLeft: "1.3rem" }}>Top Deals</div>
            <hr className='mb-0' />
            <div
                style={{
                    height: "17rem",
                    overflow: "auto",
                    scrollBehavior: "smooth",
                    width: "100%",
                    scrollbarWidth: "thin",
                    scrollbarColor: "transparent transparent",
                    transition: "scrollbar-color 0.3s ease",
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.scrollbarColor = "#888 #f1f1f1"
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.scrollbarColor =
                        "transparent transparent"
                }}
            >
                <ul className="list-unstyled py-3">
                    {topDeals !== null && topDeals?.length !== 0 ? (
                        topDeals?.map((deal, idx) => {
                            const getRandomAvatarStyle = () => {
                                const lightColors = [
                                    { bg: "#f0f8ff", text: "#1e40af" },
                                    { bg: "#f0fff4", text: "#166534" },
                                    { bg: "#fff0f0", text: "#991b1b" },
                                    { bg: "#fffaf0", text: "#92400e" },
                                    { bg: "#f8f0ff", text: "#6b21a8" },
                                    { bg: "#f0fdf4", text: "#15803d" },
                                ]
                                const randomIndex = Math.floor(
                                    Math.random() * lightColors.length
                                )
                                return lightColors[randomIndex]
                            }
                            const avatarStyle = getRandomAvatarStyle()

                            return (
                                <>
                                    <li key={idx} className="px-3">
                                        <div className="d-flex align-items-center justify-content-between w-100">
                                            <div
                                                className="d-flex align-items-center gap-2 flex-grow-1"
                                                style={{ minWidth: 0 }}
                                            >
                                                <div
                                                    className="avatar-circle flex-shrink-0"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%",
                                                        backgroundColor: avatarStyle.bg,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: avatarStyle.text,
                                                        fontWeight: "600",
                                                        fontSize: "13px",
                                                        border: `1px solid ${avatarStyle.text}20`,
                                                    }}
                                                >
                                                    <span>
                                                        {deal.name
                                                            ?.substring(0, 2)
                                                            .toUpperCase() || "NA"}
                                                    </span>
                                                </div>
                                                <div
                                                    className="d-flex flex-column flex-grow-1"
                                                    style={{ minWidth: 0 }}
                                                >
                                                    <p
                                                        className="fw-semibold mb-0 text-truncate"
                                                        style={{ textTransform: "capitalize" }}
                                                    >
                                                        {deal.name}
                                                    </p>
                                                    <span className="text-muted fs-12 text-truncate">
                                                        {deal.email?.length > 20
                                                            ? `${deal.email.substring(0, 20)}...`
                                                            : deal.email}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="fw-semibold d-flex align-items-center fs-15 text-nowrap ms-3 flex-shrink-0">
                                                <IconCurrencyRupee
                                                    size={18}
                                                    stroke={2}
                                                ></IconCurrencyRupee>
                                                {Number(deal.amount)?.toLocaleString()}
                                            </div>
                                        </div>
                                    </li>
                                    {idx !== topDeals?.length - 1 && <hr />}
                                </>
                            )
                        })
                    ) : (
                        <>
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ position: "absolute", left: "42%" }}
                            >
                                <img
                                    src={nodata}
                                    alt="nodata_found_img"
                                    style={{ width: "17rem", marginTop: "0" }}
                                />
                            </div>
                        </>
                    )}
                </ul>
            </div>
        </div >
    )
}
